// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"66a8a5f1","150":"dc723c55","202":"052c0a86","220":"0bfe52b3","388":"3f62007c","738":"9d5a2127","972":"8c975a0d"}[chunkId] + ".chunk.js";
};